// extracted by mini-css-extract-plugin
export default {"search-form":"bl_PQ flex-grow-1 form-group mb-0"};